import * as ViewModel from '@/core/presenter/viewModel';
import TrxTransactionItem from './TrxTransactionItem';
import NoActivityData from './NoActivityData';
import { MAX_TRANSACTION_ITEMS } from '@/consts';
import { observer } from 'mobx-react-lite';
import ActivityItemInfo from './ActivityItemInfo';
import { ASSET_RESET_ICON_PATH, SOL_SYMBOL_ICON_PATH } from '@/consts/imgPath';

interface IProps {
  trxTransactions: ViewModel.IResponseActivity[];
  trxBalance: string;
  trxKrw: string;
  trxPrice: number;
  onClickResetBtn: () => void;
  onClickViewType: (viewType: ViewModel.HomeViewType) => void;
  onResetSelectedAsset: () => void;
  onClickPrevTransactionBtn: () => void;
  onClickCopyBtn: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const TrxView = observer(
  ({
    trxTransactions,
    trxBalance,
    trxKrw,
    onClickResetBtn,
    onClickViewType,
    onResetSelectedAsset,
    onClickPrevTransactionBtn,
    onClickCopyBtn,
  }: IProps) => {
    const handleClickSendBtn = () => {
      onResetSelectedAsset();
      onClickViewType(ViewModel.HomeViewType.SEND);
    };

    return (
      <>
        <div className="asset-card">
          <div className="asset-header">
            <img src={SOL_SYMBOL_ICON_PATH} alt="Icon" className="asset-logo-icon" />
            <h2>솔라나</h2>
            <span className="mn-gray fw-n body-xs">SOL</span>
          </div>

          <div className="detail-asset-info">
            <div className="detail-asset-info-row">
              <h3 className="asset-title heading-2 font-medium">
                {trxBalance}
                <span className="asset-value heading-2 font-medium">SOL</span>
              </h3>
              <button type="button" className="refresh-btn" onClick={onClickResetBtn}>
                <img src={ASSET_RESET_ICON_PATH} alt="새로고침" className="refresh-icon" />
              </button>
            </div>
            <p className="detail-asset-krw text-base font-normal">{trxKrw} 원</p>
          </div>
          <div className="asset-buttons">
            <button type="button" className="asset-btn text-base font-semibold" onClick={handleClickSendBtn}>
              보내기
            </button>
            <button
              type="button"
              className="asset-btn text-base font-semibold"
              onClick={() => onClickViewType(ViewModel.HomeViewType.RECEIVE)}
            >
              받기
            </button>
          </div>
        </div>
        {trxTransactions.length === 0 && <NoActivityData />}
        {trxTransactions.length > 0 && (
          <div className="activity-list activity-list-detail">
            {trxTransactions.slice(0, MAX_TRANSACTION_ITEMS).map((trxTransaction, index) => (
              <TrxTransactionItem trxTransaction={trxTransaction} key={index} onClickCopyBtn={onClickCopyBtn} />
            ))}
            <ActivityItemInfo onClickPrevTransactionBtn={onClickPrevTransactionBtn} />
          </div>
        )}
      </>
    );
  },
);

export default TrxView;

{
  /* <div className="container">
        <div className="card-ui">
          <div className="icon-ss">
            <img src={SOL_SYMBOL_ICON_PATH} alt="Icon" />
            <h2>솔라나</h2>
            <span className="mn-gray fw-n body-xs">SOL</span>
          </div>
          <div className="total-amount fw-n">
            <h3 className="total-balance">{trxBalance} SOL</h3>
            <a href="#" className="right" onClick={onClickResetBtn}>
              <img src={ASSET_RESET_ICON_PATH} alt="reset-icon" />
            </a>
          </div>
          <div className="exchange body-xl ml-gray">{trxKrw} 원</div>
          <div className="button-group">
            <button className="solid" onClick={handleClickSendBtn}>
              보내기
            </button>
            <button className="solid" onClick={() => onClickViewType(ViewModel.HomeViewType.RECEIVE)}>
              받기
            </button>
          </div>
        </div>
        {trxTransactions.length === 0 && <NoActivityData />}
        {trxTransactions.length > 0 && (
          <div className="activity-area-ss">
            <ul className="list">
              {trxTransactions.slice(0, MAX_TRANSACTION_ITEMS).map((trxTransaction, index) => (
                <TrxTransactionItem trxTransaction={trxTransaction} key={index} onClickCopyBtn={onClickCopyBtn} />
              ))}
              <ActivityItemInfo onClickPrevTransactionBtn={onClickPrevTransactionBtn} />
            </ul>
          </div>
        )}
      </div> */
}
